/* Parkfield - offers slide out */

function openSpecialOffers() {
  document.querySelector("#offer-flyout").classList.add("open");
}

function closeSpecialOffers() {
  document.querySelector("#offer-flyout").classList.remove("open");
}

function closeSpecialOffersParent(event) {
  if (!event.target.closest(".offer-flyout.inner-container")) {
    document.querySelector("#offer-flyout").classList.remove("open");
  }
}


/* Product page - fix theme variant selector and remember selection between sizes and diff products - NICO */

function fixThemesVariantSelector(evt) {
  const variantPicker = document.querySelector("variant-picker");
  const productMeta = document.getElementById("product-meta");
  if (!productMeta) return;
  if (!variantPicker) return;

  if (
    !variantPicker.querySelector(
      'input[data-option-position="2"]:checked + label.is-disabled'
    )
  ) {
    saveSelectedVariant(evt)
    return;
  }

  restoreSize()
  saveSelectedVariant(evt)
}

document.addEventListener("variant:change", (evt) =>
  fixThemesVariantSelector(evt)
);


function saveSelectedVariant(event) {
  const variant = event.detail.variant;
  const variantPicker = document.querySelector("variant-picker");
  const sizeTypeFieldset = variantPicker.querySelector('.variant-picker__option.option-Size-Type');
  const sizeFieldset = variantPicker.querySelector('.variant-picker__option.option-Size');

  if (sizeTypeFieldset) {
    const checkedSizeType = sizeTypeFieldset.querySelector('input[type="radio"]:checked');
    if (checkedSizeType) {
      const sizeTypeValue = checkedSizeType.dataset.value;
      localStorage.setItem('savedSizeType', sizeTypeValue);

      if (sizeFieldset) {
        const checkedSize = sizeFieldset.querySelector('input[type="radio"]:checked');
        if (checkedSize) {
          const sizeValue = checkedSize.dataset.value;
          // Save size per sizeType
          let savedSizes = JSON.parse(localStorage.getItem('savedSizesByType') || '{}');
          savedSizes[sizeTypeValue] = sizeValue;
          localStorage.setItem('savedSizesByType', JSON.stringify(savedSizes));
        }
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const productMeta = document.getElementById("product-meta");
  if (!productMeta) return;

  restoreType();
  restoreSize();
});

function restoreType() {
  const savedSizeTypeVal = localStorage.getItem('savedSizeType');
  if (savedSizeTypeVal) {
    const matchingType = document.querySelector(`input[type="radio"][data-value="${savedSizeTypeVal}"]`);
    if (matchingType && !matchingType.disabled) {
      matchingType.click();
    }
  }
}

function restoreSize() {
  const sizeTypeFieldset = document.querySelector('.variant-picker__option.option-Size-Type');
  const checkedSizeType = sizeTypeFieldset?.querySelector('input[type="radio"]:checked');
  const currentSizeType = checkedSizeType?.dataset.value;

  if (!currentSizeType) return;

  let savedSizes = JSON.parse(localStorage.getItem('savedSizesByType') || '{}');
  const savedSizeVal = savedSizes[currentSizeType];

  const variantPicker = document.querySelector("variant-picker");

  if (savedSizeVal) {
    const matchingSize = document.querySelector(`input[type="radio"][data-value="${savedSizeVal}"]`);
    const matchingLabel = document.querySelector(`label[data-value="${savedSizeVal}"]`);
    if (matchingSize && matchingLabel && !matchingSize.disabled && !matchingLabel.classList.contains('is-disabled')) {
      matchingSize.click();
      return;
    }
  }

  // Fallback: select first available size
  const fallback = variantPicker.querySelector('input[data-option-position="2"]:not(:disabled) + label:not(.is-disabled)');
  fallback?.click();
}


document.addEventListener('click', (event) => {
  // Only handle clicks on size type inputs within quick-buy-drawer
  const sizeTypeInput = event.target;
  if (
    sizeTypeInput.matches('quick-buy-drawer input[type="radio"][data-option-position="1"]')
  ) {
    const quickBuyDrawer = sizeTypeInput.closest('quick-buy-drawer');
    if (!quickBuyDrawer) return;

    // Delay to allow other handlers to finish first
    setTimeout(() => {
      const fallbackLabel = quickBuyDrawer.querySelector('input[data-option-position="2"]:not(:disabled) + label:not(.is-disabled)');
      if (fallbackLabel) {
        const fallbackInput = fallbackLabel.previousElementSibling;
        if (fallbackInput) fallbackInput.click();
      }
    }, 50); // 100ms delay
  }
});



